import { render } from "./IntegrationSlackSettings.vue?vue&type=template&id=49c8617c&scoped=true"
import script from "./IntegrationSlackSettings.vue?vue&type=script&lang=js"
export * from "./IntegrationSlackSettings.vue?vue&type=script&lang=js"

import "./IntegrationSlackSettings.vue?vue&type=style&index=0&id=49c8617c&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49c8617c"]])

export default __exports__